import { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setValue } from "features/maintenance/dataStore/maintenanceSlice";

export default function useMaintenance(resource) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [error, setError] = useState(null);

    const dispatch = useDispatch();

    const filteredItems = useMemo(() => {
        if (!keyword.trim()) {
            return items;
        }

        const searchText = keyword.toLowerCase();

        return items.filter((item) =>
            resource.searchFields.some((field) => {
                const value = item[field];

                return (
                    value && value.toString().toLowerCase().includes(searchText)
                );
            })
        );
    }, [items, keyword, resource]);

    const search = useCallback(
        async (signal) => {
            try {
                setLoading(true);

                // const data = await resource.search();
                // const response = await resource.service.search();
                const response = await resource.service.search(undefined, {
                    signal
                });

                setItems(response.data);
                if (resource?.setter) {
                    dispatch(
                        setValue({
                            field: resource.setter,
                            value: response.data
                        })
                    );
                }
            } catch (e) {
                if (axios.isCancel(e)) {
                    // Expected: a prior in-flight request was superseded. Not a real error.
                    return;
                }
                setError(e);
                console.log("Error fetching data:", e);
            } finally {
                /*setLoading(false);*/
                if (!signal?.aborted) {
                    setLoading(false);
                }
            }
        },
        [resource]
    );

    /*useEffect(() => {
        search();
    }, [search]);*/

    /* useEffect(() => {
         const controller = new AbortController();

         search(controller.signal);

         return () => {
             controller.abort();
         };
     }, [search]);*/

    return {
        items,
        loading,
        search,
        refresh: search,
        filteredItems,
        keyword,
        setKeyword,
        error
    };
}
